import { apiSlice } from "app/api/apiSlice"

export const usersApiSlice = apiSlice.injectEndpoints({
    // tagTypes: ['users'],
    endpoints: builder => ({
        getUsers: builder.query({
            query: () => '/user',
            keepUnusedDataFor: 3600,
            providesTags: ['users']
        })
    })
})

export const {
    useGetUsersQuery
} = usersApiSlice 